// DataSanitizer.js

// From _lodash escape.js
//  ... along with escapeHTML() below (renamed: in lodash, the function is: escape())
// ==========================
const htmlEscapes = {
    '&': '&amp;',
    '<': '',
    '>': '',
    // '<': '&lt;',
    // '>': '&gt;',
    '"': '&quot;',
    "'": "'"
    // "'": '&#39;'
}

/** Used to match HTML entities and HTML characters. */
const reUnescapedHtml = /[&<>"']/g
const reHasUnescapedHtml = RegExp(reUnescapedHtml.source)
// ==========================

// From _lodash
function getTag(value) {
    if (value == null) {
        return value === undefined ? '[object Undefined]' : '[object Null]'
    }
    return Object.prototype.toString(value)
}

// From _lodash
function isString(value) {
    const type = typeof value
    return type === 'string' || (type === 'object' && value != null && !Array.isArray(value) && getTag(value) == '[object String]')
}


// From Validator.js
function isNumber(val) {
    if (typeof val === 'number' && isFinite(val)) return true; // e.g. 0/0 or 4/0
    if (typeof val === 'string') {
        val = val.trim();
        if (val === '') return false;
        //https://stackoverflow.com/questions/6449611/check-whether-a-value-is-a-number-in-javascript-or-jquery
        return !isNaN(+val) && isFinite(val)
    }
    return false;
}


const DataSanitizer = {
    resultValue: null,
    valDefined: function (v) {
        if (v === undefined) return false;
        if (v === null) return false;
        return true;
    },
    load: function (value) {
        this.resultValue = value;
        return this;
    },
    trim: function () {
        if (this.valDefined(this.resultValue) && isString(this.resultValue)) {
            this.resultValue = this.resultValue.toString().trim();
        }
        return this;
    },

    // From _lodash 
    // Converts the characters "&", "<", ">", '"', and "'" in `string` to their corresponding HTML entities.
    escapeHTML: function () {
        // Return if resultValue is boolean (note: lodash isBoolean has a couple more checks... this will do for now).
        // Otherwise, this.resultValue is boolean false and so this function sets resultValue to '' (empty string) 
        // because of ternary 'false' clause below: (this.resultValue || '')
        if (this.resultValue === true || this.resultValue === false) {
            return this;
        }
        if (this.valDefined(this.resultValue)) {
            this.resultValue = reHasUnescapedHtml.test(this.resultValue)
                ? this.resultValue.replace(reUnescapedHtml, (chr) => htmlEscapes[chr])
                : (this.resultValue || '')
        }
        return this;
    },


    stripHTML: function () {
        // if (val === undefined) { val = this.resultValue }
        if (document) {
            // Create a new div element
            var temporalDivElement = document.createElement("div");
            // Set the HTML content
            temporalDivElement.innerHTML = this.resultValue;
            // Retrieve the text property of the element (cross-browser support)
            this.resultValue = temporalDivElement.textContent || temporalDivElement.innerText || "";
        }
        return this;
    },
    normalizeEmail: function () {
        if (this.valDefined(this.resultValue)) {
            // var emailRegExp = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
            // -- Update 6/2020 --
            // https://stackoverflow.com/questions/50330109/simple-regex-pattern-for-email
            // var emailRegExp = /[a-z0-9\._%+!$&*=^|~#%'`?{}/\-]+@([a-z0-9\-]+\.){1,}([a-z]{2,16})/
            var emailRegExp = /[a-z0-9._%+!$&*=^|~#%'`?{}/-]+@([a-z0-9-]+\.){1,}([a-z]{2,16})/;
            var isEmailAddress = emailRegExp.test(this.resultValue.toString());
            if (isEmailAddress) {
                this.resultValue = this.resultValue.toLowerCase();
            }
        }
        return this;
    },
    truncate: function (length) {
        if (!isNumber(length)) {
            return this;
        }
        if (length < 0) {
            return this;
        }
        if (this.valDefined(this.resultValue)) {
            // Check and store if the value being truncated is a number.
            var isNum = typeof this.resultValue === 'number';
            this.resultValue = this.resultValue.toString().substring(0, length);
            // Since truncate op above converts value to a string, if the value WAS a number to begin with, convert it back to a number
            if (isNum) {
                this.resultValue = +this.resultValue;
            }
        }
        return this;
    },

    getResult: function () {
        return this.resultValue;
    }

}

export { DataSanitizer };
